var _defs, _path, _path2, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10, _line11, _line12, _line13, _polyline, _polyline2, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _path3, _path4, _path5, _path6, _path7, _path8, _line32;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKursIntensywny(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    "data-name": "Warstwa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 257.6 283.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-1,.cls-2,.cls-3{stroke:#000;stroke-miterlimit:10;}.cls-2,.cls-3{fill:#ac893a;}.cls-3{stroke-width:1.1px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "kurs_intensywny") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.45,236.55A11.61,11.61,0,0,1,63.85,248a11.32,11.32,0,0,1-8.3-3.4,10.94,10.94,0,0,1-3.4-8.2,11.32,11.32,0,0,1,3.4-8.3,10.94,10.94,0,0,1,8.2-3.4,11.32,11.32,0,0,1,8.3,3.4A12.14,12.14,0,0,1,75.45,236.55Z",
    transform: "translate(-21.65 -17.85)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.45,289.95a11.61,11.61,0,0,1-11.6,11.5,11.32,11.32,0,0,1-8.3-3.4,10.94,10.94,0,0,1-3.4-8.2,11.32,11.32,0,0,1,3.4-8.3,10.94,10.94,0,0,1,8.2-3.4,11.32,11.32,0,0,1,8.3,3.4A11.79,11.79,0,0,1,75.45,289.95Z",
    transform: "translate(-21.65 -17.85)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 104.9,
    x2: 172.3,
    y2: 104.9
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 95.6,
    x2: 257.6,
    y2: 95.6
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 85.9,
    x2: 62.9,
    y2: 85.9
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 76.6,
    x2: 62.9,
    y2: 76.6
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 66.8,
    x2: 62.9,
    y2: 66.8
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 57.5,
    x2: 62.9,
    y2: 57.5
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 47.7,
    x2: 62.9,
    y2: 47.7
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 38.4,
    x2: 62.9,
    y2: 38.4
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 29.1,
    x2: 62.9,
    y2: 29.1
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 19.8,
    x2: 62.9,
    y2: 19.8
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 10,
    x2: 62.9,
    y2: 10
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 143.1,
    x2: 37.6,
    y2: 143.1
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 133.8,
    x2: 37.6,
    y2: 133.8
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 124,
    x2: 37.6,
    y2: 124
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 114.7,
    x2: 37.6,
    y2: 114.7
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "62.9 0.5 62.9 95.3 86.2 95.3 86.2 0.5"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "172.3 96 172.3 196.3 195.6 196.3 195.6 96"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 86.2,
    y1: 85.6,
    x2: 256.9,
    y2: 85.6
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 86.2,
    y1: 76.3,
    x2: 256.9,
    y2: 76.3
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 86.2,
    y1: 66.5,
    x2: 256.9,
    y2: 66.5
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 86.2,
    y1: 57.2,
    x2: 256.9,
    y2: 57.2
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 86.2,
    y1: 47.4,
    x2: 256.9,
    y2: 47.4
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 86.2,
    y1: 38.1,
    x2: 256.9,
    y2: 38.1
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 86.2,
    y1: 28.8,
    x2: 256.9,
    y2: 28.8
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 86.2,
    y1: 19.5,
    x2: 256.9,
    y2: 19.5
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 86.2,
    y1: 9.8,
    x2: 256.9,
    y2: 9.8
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 195.6,
    y1: 104.9,
    x2: 257.6,
    y2: 104.9
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 195.6,
    y1: 143.1,
    x2: 257.6,
    y2: 143.1
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 195.6,
    y1: 133.8,
    x2: 257.6,
    y2: 133.8
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 195.6,
    y1: 124,
    x2: 257.6,
    y2: 124
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 195.6,
    y1: 114.7,
    x2: 257.6,
    y2: 114.7
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 110,
    y1: 143.1,
    x2: 172.3,
    y2: 143.1
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 110,
    y1: 133.8,
    x2: 172.3,
    y2: 133.8
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 110,
    y1: 124,
    x2: 172.3,
    y2: 124
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 110,
    y1: 114.7,
    x2: 172.3,
    y2: 114.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M96.25,103.25a52.2,52.2,0,1,0,52.2,52.2A52.17,52.17,0,0,0,96.25,103.25Z",
    transform: "translate(-21.65 -17.85)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M205.55,192.95a52.2,52.2,0,1,0,52.2,52.2A52.17,52.17,0,0,0,205.55,192.95Z",
    transform: "translate(-21.65 -17.85)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M75.45,183.25a11.61,11.61,0,0,1-11.6,11.5,11.32,11.32,0,0,1-8.3-3.4,10.94,10.94,0,0,1-3.4-8.2,11.32,11.32,0,0,1,3.4-8.3,10.94,10.94,0,0,1,8.2-3.4,11.32,11.32,0,0,1,8.3,3.4A11.79,11.79,0,0,1,75.45,183.25Z",
    transform: "translate(-21.65 -17.85)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M257.25,207.85a11.61,11.61,0,0,1-11.6,11.5,11.32,11.32,0,0,1-8.3-3.4,10.94,10.94,0,0,1-3.4-8.2,11.32,11.32,0,0,1,3.4-8.3,10.94,10.94,0,0,1,8.2-3.4,11.61,11.61,0,0,1,11.7,11.8Z",
    transform: "translate(-21.65 -17.85)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M257.25,261.15a11.61,11.61,0,0,1-11.6,11.5,11.32,11.32,0,0,1-8.3-3.4A10.94,10.94,0,0,1,234,261a11.32,11.32,0,0,1,3.4-8.3,10.94,10.94,0,0,1,8.2-3.4,11.61,11.61,0,0,1,11.7,11.8Z",
    transform: "translate(-21.65 -17.85)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M257.25,154.45a11.61,11.61,0,0,1-11.6,11.5,11.32,11.32,0,0,1-8.3-3.4,10.94,10.94,0,0,1-3.4-8.2,11.32,11.32,0,0,1,3.4-8.3,10.94,10.94,0,0,1,8.2-3.4,11.32,11.32,0,0,1,8.3,3.4A11.55,11.55,0,0,1,257.25,154.45Z",
    transform: "translate(-21.65 -17.85)"
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 0.5,
    x2: 256.9,
    y2: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKursIntensywny);
export default __webpack_public_path__ + "static/media/kurs_intensywny.7231843fc938079ae16601f87b5d60ed.svg";
export { ForwardRef as ReactComponent };